

<div class="h36"></div>
<div class="content fixTarget" id="content"><!-- lightBG-->
  <div>
    <div class="sonMod1Box padT20B40">
      <div class="w1224 rela">
        <div class="mianbaoDiv">
          <div class="floatL">您所在的位置：
            <a *ngIf="fromType == '0'" [routerLink]="['/gzEcommerceSearch']" [queryParams]="{userId: userId, userName: userName}">电商商务诚信</a>
            <a *ngIf="fromType == '1'" [routerLink]="['/gzLogisticsSearchComponent']" [queryParams]="{userId: userId, userName: userName}">物流商务诚信</a>
            》<span *ngIf="fromType == '0'">电商资讯</span>
            <span *ngIf="fromType == '1'">物流资讯</span></div>
          <div class="floatR taRight"><a onclick="history.go(-1);">返回上一页</a></div>
          <div style="clear: both"></div>
        </div>
        <!--<h2 class="position"><div class="floatL"><i><img src="../../../assets/images/position.png" align="absmiddle"/></i><a href="index.html">新华信用</a><span class="fontST">&nbsp;>&nbsp;</span><span>信用动态</span>&lt;!&ndash;<a  class="floatL TitBlueGoData">前往监测中心</a>&ndash;&gt;</div><div class="floatR"></div></h2>-->

        <div class="BGwhite articleBox" style="width: 100%; margin: 0 auto;">
          <h2 class="titBlue">
            <div class="floatL"><i></i>
              <span *ngIf="fromType == '0'">电商资讯</span>
              <span *ngIf="fromType == '1'">物流资讯</span>
            </div>
            <div class="floatR"></div></h2>

          <dl class="oneList" *ngFor="let item of newsList">
            <dt><img width="120" height="80" src="{{item.picLinks ? item.picLinks : '../../../assets/images/news_default.png'}}"/></dt>
            <dd style="width: 85%;">
              <!--<h3><a href="{{item.artUrl}}" target="_self" >{{item.title}}</a></h3>-->
              <h3><a [routerLink]="['/informationDetail']" [queryParams]="{url: item.artUrl,userId: userId, userName: userName, fromType: fromType}" target="_self" >{{item.title}}</a></h3>
              <span class="listTime">{{item.pubTime | date:'yyyy-MM-dd HH:mm'}}</span>
              <!--<p class="Resis">{{item.subTitle}}</p>-->
              <p class="Resis" [innerHTML]="item.subTitle | safeHTML">&nbsp;</p>
            </dd>
          </dl>

          <app-page [totals]="totals" [showSizeChanger]="false"></app-page>

        </div>

      </div>
    </div>
  </div>
</div>



// WEBPACK FOOTER //
// E:/java/gd-project/credit-gd-web/src/app/components/information-list/information-list.component.html